import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  standalone: true,
  selector: 'app-empty-state',
  styleUrls: ['./empty-state.component.scss'],
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent {
  @Input() public imagePath: string;
  @Input() public buttonText: string[];
  @Input() public buttonTooltip: string[];
  @Input() public customClass: string;
  @Output() public buttonClicked = new EventEmitter();

  constructor(public sanitizer: DomSanitizer) {}
}
